const PATHS = {

  app: {
    root: "/",
    setGoal: "/set-goal",
    personalInfo: "/personal-info",
    settings: "/settings",
    overview: "/overview",
    userPlan: "/user-plan",
    welcomeOnboarding: "/welcome-onboarding",

    favoriteMeal: {
      details: "/favorite-meal/:id",
    },

    yourGoal: {
      root: "/your-goal",
      updateBodyAndGoal: "/your-goal/update-body-and-goal",
      manualEditGoal: "/profile/manual-edit-goal",
    },

    profile: {
      createAccount: "/profile/create-account",
    },

    food: {
      create: "/food/create",
      details: "/food/:id/details",
      edit: "/food/:id/edit",
      search: "/food/search",
    },

    myFoods: {
      root: "/my-foods",
      schedules: "/my-foods/schedules",
      recipes: "/my-foods/recipes",
    },

    meal: {
      tutorial: "/tutorial",
      edit: "/meal/:id/edit",
      scan: "/meal/scan",
    },

    schedule: {
      details: "/schedule/:id/details",
    },

    barcodeScanner: {
      root: "/barcode-scanner",
    },

    water: {
      root: "/water",
    },
  },
  auth: {
    loginInNativeApp: "/auth/login-in-native-app",
  },
}

export default PATHS
